import React from 'react';

interface TrashIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function TrashIcon({ width = 24, height = 24, fill = 'currentColor', ...props }: Readonly<TrashIconProps>) {
	return (
		<svg
			{...props}
			fill="none"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.4375 3.71H8.25C8.35313 3.71 8.4375 3.6245 8.4375 3.52V3.71H15.5625V3.52C15.5625 3.6245 15.6469 3.71 15.75 3.71H15.5625V5.42H17.25V3.52C17.25 2.68162 16.5773 2 15.75 2H8.25C7.42266 2 6.75 2.68162 6.75 3.52V5.42H8.4375V3.71ZM20.25 5.42H3.75C3.33516 5.42 3 5.75962 3 6.18V6.94C3 7.0445 3.08438 7.13 3.1875 7.13H4.60312L5.18203 19.5512C5.21953 20.3611 5.88047 21 6.67969 21H17.3203C18.1219 21 18.7805 20.3635 18.818 19.5512L19.3969 7.13H20.8125C20.9156 7.13 21 7.0445 21 6.94V6.18C21 5.75962 20.6648 5.42 20.25 5.42ZM17.1398 19.29H6.86016L6.29297 7.13H17.707L17.1398 19.29Z"
				fill={fill}
			/>
		</svg>
	);
}
